export const services = {
  label: 'Services & Tools',
  heading: '展開しているサービス・ツール',
  intro:
    'SNS、各種管理ツール、コミュニティ機能をここに順次公開します。「詳細を見る」をクリックすると各サービスの詳細をご覧いただけます。',
  comingSoonTitle: 'さらに多くのサービス・ツールを準備中',
  comingSoonBody:
    'EachTeachでは継続的に新しいツールやリソースを追加していく予定です。コミュニティに登録して最新情報をお受け取りください。',

  // ServiceCard
  card: {
    showDetail: '詳細を見る',
    close: '閉じる',
    openLink: 'リンクを開く',
  },
};
